import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';
var DataResolver = /*@__PURE__*/ (function () {
    function DataResolver() {
    }
    DataResolver.prototype.resolve = function (route, state) {
        return of({ res: 'I am data' });
    };
    return DataResolver;
}());
export { DataResolver };
/**
 * An array of services to resolve routes with data.
 */
export var APP_RESOLVER_PROVIDERS = [
    DataResolver
];



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/app.resolver.ts
// module id = null
// module chunks = 